<template>
  <div>
    <page-header title="Tax" breadcrumb="Accounting > Tax" />
    <section class="bg-white pt-2">
      <div class="flex items-center border-b-2 border-gray-200">
        <div class="col-12 col-md-6 flex items-center">
          <abbr class="mr-2">VAT Analytics</abbr>
          <span class="w-48">
            <el-select
              class="mt-1"
              v-model="location"
              placeholder="--Select Location--"
            >
              <el-option
                v-for="type in ['cardTypes']"
                :key="type"
                :label="type"
                :value="type"
              >
              </el-option>
            </el-select>
          </span>
        </div>
        <div class="col-12 col-md-6 flex justify-end items-center">
          <label class="mr-2">From:</label>
          <el-date-picker />
          <label class="mx-2">To:</label>
          <el-date-picker />
        </div>
      </div>

      <div class="flex py-3">
           <div class="w-3/12 px-2 border-none" v-for="vat in vatAnalysis" :key="vat.name">
            <span class="border-toper block py-1"
            :class="[vat.market == 'success' ? 'text-primary-yellow' : 'text-red-600']"
            >Totals VAT on Sales</span>
            <div class="my-2 flex items-center w-full">
                <p class=" w-1/2">
                  ₦ 2,157,667.15
                  <abbr class="text-xs text-primary-yellow block w-full">+3.2%</abbr>
                </p>
                <p class="pl-1 flex justify-end w-1/2"><GraphIcon :type="vat.market"/></p>
            </div>
           </div>
      </div>

      <div class="flex items-center pt-2">
            <div class="col-md-3 flex items-center">   
              <img src="@/assets/images/icons/filter-icon.svg" class="mr-2" />
               <span class="w-48">
              <el-select
                class="mt-1"
                v-model="location"
                placeholder="--Select Location--"
              >
                <el-option
                  v-for="type in ['cardTypes']"
                  :key="type"
                  :label="type"
                  :value="type"
                >
                </el-option>
              </el-select>
            </span>
          </div>
          <div class="col-md-6 col-12 flex items-center">
              <label class="mr-2">From:</label>
              <el-date-picker />
              <label class="mx-2">To:</label>
              <span  class="w-28"><el-date-picker /></span>
              <img src="@/assets/images/icons/reload-icon.svg" class="ml-2"/>
          </div>

          <div class="col-md-3 col-12 flex items-center justify-end">
            <button class="flex items-center">
              <img
                class="cursor-pointer mr-1"
                src="@/assets/images/icons/black-setting-icon.svg"
                alt="search icon"
              />
            Outlet & Taxes
            </button>
        </div>
      </div>
    </section>

    <div>
           <TaxTable/> 
           <PaginationControl
           :total="totalCollection"
           :pageNumber="sortOptions.pageNumber"
           @pageNumber="setPageDisplayCollection"
           @pageSize="setNumDisplayCollection"
         />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import GraphIcon  from "@/assets/images/accounting/GraphIcon.vue"
import TaxTable from "@/components/3pl/Accounting/Tax/TaxTable.vue";
import PaginationControl from "@/components/UI/pagination";

export default {
  components: { PageHeader, GraphIcon, TaxTable, PaginationControl },
  data() {
    return {
      location: "",
      sortOptions: {
          pageSize: 10,
          pageNumber: 1,
          startDate: null,
          endDate: null,
          searchString: "",
        },
      vatAnalysis: [
        {
          name: "Totals VAT on Sales",
          market: 'success'
        },
        {
          name: "Totals VAT on Purchase",
          market: 'loss'
        },
        {
          name: "Total VAT Payable",
          market: 'success'
        },
        {
          name: "Totals VAT Paid",
          market: 'success'
        }
      ]
    };
  },
  methods: {
      setNumDisplayCollection(val) {
        this.sortOptions = { ...this.sortOptions, pageSize: val };
      },
      setPageDisplayCollection(val) {
        this.sortOptions = { ...this.sortOptions, pageNumber: val };
      },
      sortItemProps(val) {
        this.sortOptions = { ...this.sortOptions, ...val };
      },
    },
};
</script>

<style lang="scss" scoped>
.el-input {
  outline: none;
  border: none;
}
.border-toper{
  border-bottom: 1px dashed rgb(200, 193, 193);
}
</style>
